import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DynamicFormControlService } from '../dynamic-forms/dynamic-form-control.service';
import { DynamicFormComponent } from '../dynamic-forms/form-components/dynamic-form/dynamic-form.component';
import { FormControlBase } from '../dynamic-forms/form-models/form-control-base';
import { DynamicDetailsService } from './dynamic-details.service';

@Component({
  selector: 'hb-dynamic-details',
  templateUrl: './dynamic-details.component.html',
  styleUrls: ['./dynamic-details.component.css'],
})
export class DynamicDetailsComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('dynForm', { static: false }) dynForm: DynamicFormComponent;

  private unsubscribe: Subject<boolean> = new Subject();

  private lockDirtyEvent: boolean;

  @Input() controls: FormControlBase<any>[] = [];

  @Input() item: any;

  @Input() isReadOnly: boolean;
  @Input() separateByGroups: boolean = false;
  @Input() separateGroupsByAccordion: boolean =false;

  @Output() detailsValidChanged = new EventEmitter<boolean>();
  @Output() onClickRaised: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDropdownChangeRaised: EventEmitter<any> = new EventEmitter<any>();

  set detailsValid(value) {
    this.detailsService.detailsChanged.next(value);
    this.detailsValidChanged.emit(value);
  }

  get detailsValid() {
    return this.detailsService.detailsChanged.getValue();
  }

  @Output() formGroupCreated = new EventEmitter<FormGroup>();
  @Output() onSaved: EventEmitter<any> = new EventEmitter();
  @Input() trackDirtyEvent: boolean = false;

  constructor(
    private dynamicFormControlService: DynamicFormControlService,
    private changeDetector: ChangeDetectorRef,
    private detailsService: DynamicDetailsService,
  ) {}

  ngOnInit() {
    this.detailsService.saveDetailsSubmitted.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.dynamicFormControlService.commit(this.controls);
      this.onSaved.emit();
    });

    this.detailsService.markAsPristine.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      if (this.dynForm && this.dynForm.form) {
        this.dynForm.form.markAsPristine();
      }
    });

    this.resetDetailsValid();
  }

  ngOnChanges(): void {
    // Create form group in child DynamicFormComponent before mapping item to controls
    this.changeDetector.detectChanges();

    this.mapItemToControls();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  mapItemToControls(): any {
    this.lockDirtyEvent = true;
    this.dynamicFormControlService.setModel(this.item, this.controls);
    // Call detectChanges to avoid ExpressionChangedAfterItHasBeenCheckedError
    this.changeDetector.detectChanges();
    this.lockDirtyEvent = false;
  }

  onClickEvent() {
    this.onClickRaised.emit();
  }

  onDropdownChange(event: any): void {
    this.onDropdownChangeRaised.emit(event);
  }

  formValidChange(valid) {
    this.detailsValid = valid;
  }

  formDirtyChange(dirty) {
    if (this.lockDirtyEvent || !this.trackDirtyEvent) return;
    this.detailsService.formIsDirty = dirty;
  }

  private resetDetailsValid(): void {
    if (this.dynForm && this.dynForm.form) {
      if (this.detailsValid !== this.dynForm.form.valid) {
        this.formValidChange(this.dynForm.form.valid);
      }
    }
  }
}
